import { forwardRef, MouseEventHandler, RefObject } from 'react';
import { CDN_URL } from 'utils/assets';
import { cn } from 'utils/cn';

import Button from '../../atoms/Button';

const GOOGLE_ICON_SRC = `${CDN_URL}/images/icons/google.svg`;

// A shorter list of props is provided intentionally since we want this button
// to remain pretty consistent across our pages.
export interface GoogleButtonProps {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  type?: 'signin' | 'signup';
  overrideText?: string;
  disabled?: boolean;
  className?: string | null;
}

const DEFAULT_SIGN_IN_TEXT = 'Sign in with Google';
const DEFAULT_SIGN_UP_TEXT = 'Sign up with Google';

const GoogleButton = forwardRef(
  ({ onClick, type = 'signin', disabled = false, overrideText, className }: GoogleButtonProps, ref: RefObject<HTMLButtonElement>) => {
    let cta = DEFAULT_SIGN_UP_TEXT;

    if (overrideText) {
      cta = overrideText;
    } else if (type === 'signin') {
      cta = DEFAULT_SIGN_IN_TEXT;
    }
    return (
      <Button
        ref={ref}
        className={cn('align-center h-full justify-center', className)}
        onClick={onClick}
        disabled={disabled}
        variant='social'
      >
        <img src={GOOGLE_ICON_SRC} />
        <div className='ml-6 select-none'>{cta}</div>
      </Button>
    );
  }
);

export default GoogleButton;
